
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/backend/built-in-adapters/echo-adapter",
      function () {
        return require("private-next-pages/x/react-chat/backend/built-in-adapters/echo-adapter.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/backend/built-in-adapters/echo-adapter"])
      });
    }
  